import { searchApiClient } from '@api/clients';
import { SearchFilters } from '@api/api';
import { useQuery } from 'react-query';

export const fetchSearchFilters = async (): Promise<SearchFilters> => {
  const { data } = await searchApiClient.searchFiltersGet();

  return data;
};

export const useSearchFilters = () => {
  return useQuery<SearchFilters>(['search-filters'], fetchSearchFilters);
};
